import { createRoutine } from 'redux-saga-routines'

export const SET = 'BLOG/SET'
export const CONTENT = createRoutine('BLOG/CONTENT')
